// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: any = {
  production: true,
  // tinyMceKey: 'nfj6w8hc6i2j2nlr19s0ebfd8s5vwwziz7431xvng8u8emw7',
  tinyMceKey: 'zpeml00qcb4dhnwsdedtxr0fuca8fvyxs9qm85xr90sad0mn',
  AlertBeforeTimeOutSeconds:300,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
